// extracted by mini-css-extract-plugin
export default {"header":"styles_header__gcJCs","message":"styles_message__FFY7z"};